import { isEditorActive, Text } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';

const ProgressBar = ({ fields }) => {
  const width =
    fields.width?.value || Math.floor((fields.step?.value / fields.steps?.value) * 100) || 0;

  const renderSteps = () => {
    if (!isEditorActive() && (!fields.step || !fields.steps)) {
      return null;
    } else {
      return (
        <span
          className="vds-progress-path__progress-text"
          data-testid={`${fields.testid?.value}-current-step`}
        >
          <Text field={fields.stepTitle} />
          &nbsp;
          <Text field={fields.step} />
          &nbsp; of &nbsp;
          <Text field={fields.steps} />
        </span>
      );
    }
  };

  return (
    <div className="vds-d2c-form-page__section">
      <div className="vds-padding-bottom-spacing-0">
        <div className="vds-progress-bar vds-progress-bar--d2c" data-testid={fields.testid?.value}>
          <div className="vds-progress-bar__inner">
            <div
              role="progressbar"
              aria-valuenow={width}
              aria-valuemin="0"
              aria-valuemax="100"
              className="vds-progress-bar__indicator"
              style={{ width: `${width}%` }}
              data-testid={`${fields.testid?.value}-progress-bar`}
            ></div>
          </div>
        </div>
        <div className="vds-progress-path vds-progress-path--d2c">
          <div className="vds-progress-path__inner">
            {fields?.stepName?.value && (
              <div className="vds-progress-path__title-container">
                <Text
                  tag="span"
                  className="vds-progress-path__primary-title"
                  field={fields.stepName}
                  data-testid={`${fields.testid?.value}-step-name`}
                />
              </div>
            )}
            <div className="vds-progress-path__progress">{renderSteps()}</div>
            {fields?.nextLabel?.value && (
              <div className="vds-progress-path__next">
                <Text
                  className="vds-progress-path__next-step"
                  field={fields.nextLabel}
                  data-testid={`${fields.testid?.value}-next-label`}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
